import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useEffect, useRef } from "react";
import Modal from "../components/modules/modal";
import SliderRelated from "./slider-related";
import { Link } from "./atoms/link";

const CartModal = ({
  show,
  onHide,
  msg,
  msgKey,
  icon = "tick",
  cartUrl,
  loading,
  sliderProducts,
  lineId,
}) => {
  const ref = useRef(null);

  const { labelManagerLabels, sliderProductsACLine } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        goToCart
        continueOnTheShop
        anErrorAsOccurred
        itemAddedToCart
        noProductsInCart
        relatedProducts
        cartModalRelatedProducts
        cartModalRelatedProductsAc
      }
      sliderProductsACLine: liferayPageLine(lineId: { eq: "333" }, isDefaultLine: { eq: "yes" }) {
        slug
      }
    }
  `);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`cart-modal${show ? " cart-modal--show" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        role="dialog"
        aria-hidden={!show || !cartUrl}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        onKeyDown={onKeyDown}
      >
        {loading ? (
          <div className="cart-modal__loading"></div>
        ) : (
          <div className="modal cart-preview-modal visible" id="cart-preview-modal">
            <span className="modal-backdrop close-modal"></span>
            <div className="modal-content">
              <div className="modal-body">
                <div className="cart-preview-modal__message">
                  {icon ? (
                    <div className={`cart-modal__icon cart-modal__icon--${icon}`}>
                      <span className={`icon-${icon}`}></span>
                    </div>
                  ) : null}
                  <h3>{msgKey && labelManagerLabels[msgKey] ? labelManagerLabels[msgKey] : msg}</h3>
                  <div className="btns">
                    {cartUrl ? (
                      <div className="cart-modal__cta">
                        <a href={cartUrl} className="cart-modal__close button primary blue">
                          {labelManagerLabels.goToCart}
                        </a>
                      </div>
                    ) : null}
                    {lineId === 333 && sliderProductsACLine?.slug ? (
                      <Link
                        className="cart-modal__close button primary white"
                        to={sliderProductsACLine.slug}
                        onClick={onHide}
                      >
                        {labelManagerLabels.cartModalRelatedProductsAc}
                      </Link>
                    ) : (
                      <button className="cart-modal__close button primary white" onClick={onHide}>
                        {labelManagerLabels.continueOnTheShop}
                      </button>
                    )}
                  </div>
                </div>
                {lineId !== 333 && sliderProducts?.length ? (
                  <SliderRelated
                    data={sliderProducts}
                    labelManagerLabels={labelManagerLabels}
                    isCartModal
                    onHide={onHide}
                  />
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CartModal;
